import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import Section from './layout/Section';
import ScrollReveal from './animations/ScrollReveal';
import TerminalFrame from './effects/TerminalFrame';
import { processSteps } from '../data/profile';

export default function Process() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <Section
      id="process"
      eyebrow="How I work"
      title="My process"
      lead="Five stages. No mystery. You always know what’s happening and what comes next."
      className="border-y border-slate-200/80 bg-white dark:border-emerald-500/10 dark:bg-slate-950/80"
    >
      <div className="relative">
        <motion.span
          aria-hidden="true"
          className="absolute left-[1.35rem] top-2 hidden w-px bg-gradient-to-b from-emerald-500/50 via-cyan-500/20
                     to-transparent lg:left-0 lg:right-0 lg:top-[1.6rem] lg:block lg:h-px lg:w-full
                     lg:bg-gradient-to-r"
          initial={prefersReducedMotion ? false : { scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          style={{ transformOrigin: 'left' }}
        />

        <ol className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5 lg:gap-4">
          {processSteps.map((step, index) => (
            <li key={step.number}>
              <ScrollReveal direction="up" delay={index * 0.08}>
                <TerminalFrame
                  title={`stage_${step.number}`}
                  className="group h-full transition-shadow duration-500 hover:shadow-glow-green"
                >
                  <motion.span
                    className="mb-3 inline-flex h-8 w-8 items-center justify-center rounded-md border
                               border-emerald-500/20 bg-emerald-500/10 font-mono text-[12px] font-bold
                               text-emerald-600 dark:text-emerald-400"
                    whileHover={prefersReducedMotion ? undefined : { scale: 1.08, rotate: -3 }}
                  >
                    {step.number}
                  </motion.span>
                  <h3 className="text-sm font-semibold text-slate-900 dark:text-white">{step.title}</h3>
                  <p className="mt-2 text-[12px] leading-relaxed text-slate-600 dark:text-slate-400">
                    {step.body}
                  </p>
                  <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.16em] text-emerald-600/70 dark:text-emerald-500/60">
                    exit_code: 0
                  </p>
                </TerminalFrame>
              </ScrollReveal>
            </li>
          ))}
        </ol>
      </div>
    </Section>
  );
}
